import {
  Box,
  FormLabel,
  Grid,
  IconButton,
  Input,
  Modal,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import React, { useEffect } from 'react';
import Iconify from '../../iconify/Iconify';
import '../../../css/table.css';

function Editusermodel(props) {
  const { Editmodel, name, state, handleChange, fielderror, handleEditClose, handleeditok } = props;

  const obj = {
    UserId: state?.UserId,
    EmployerId: state?.EmployerId,
    LOPDays: state?.LOPDays,
    YearEndSettlement: state?.YearEndSettlement,
    Terminated: state?.Terminated,
    Notice: state?.Notice,
    Probation: state?.Probation,
    TemporaryDeactivation: state?.TemporaryDeactivation,
    WithdrawalFactor: state?.WithdrawalFactor,
    MinAmtValue: state?.MinAmtValue,
    EmployeeOutStanding: state?.EmployeeOutStanding,
    LastDateOfEmployement: state?.LastDateOfEmployement,
    MaxSalaryBand: state?.MaxSalaryBand,
    WithdrawnAmount: state?.WithdrawnAmount,
  };

  const style1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 10,
    p: 2,
    transition: 'left 0.5s ease-in-out',
  };
  const style2 = {
    display: 'flex',
    flexDirection: 'column',
  };
  return (
    <>
      {/* edit model */}

      <Modal
        style={style2}
        open={Editmodel}
        onClose={handleEditClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style1, left: Editmodel ? '50%' : '-50%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h2>Update {name}</h2>
            <Iconify style={{ cursor: 'pointer' }} onClick={handleEditClose} icon={'material-symbols:close'} />
          </div>
          <Grid container>
            {Object.keys(obj).map((e) => {
              return (
                <>
                  <Grid sx={style2} item xs={12} sm={6} md={4} xl={3}>
                    <FormLabel>{e} :</FormLabel>
                    <Input
                      disabled={e === 'UserId'}
                      type="text"
                      name={e}
                      onChange={handleChange}
                      label={e}
                      value={state?.[e]}
                    />
                    {/* <div style={{ color: 'red' }}>{fielderror.EmployerId}</div> */}
                  </Grid>
                </>
              );
            })}
          </Grid>
          <Typography style={{ fontWeight: 'Bold', marginTop: '20px' }}>Tickets : </Typography>
          <ul style={{ marginLeft: '20px' }}>
            {state?.tickets?.map((item) => (
              <>
                <li>
                  {item?.ticketId} - {item?.data}
                </li>
              </>
            ))}
          </ul>
          <Button onClick={() => handleeditok()} style={{ marginTop: '20px' }} variant="contained">
            Update
          </Button>
          <Button style={{ marginTop: '20px', marginLeft: '10px' }} onClick={handleEditClose} variant="outlined">
            Cancel
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default Editusermodel;
